import React from "react";

const RadioGroup = ({
  label,
  name,
  options = [],
  selectedValue,
  onChange,
  disabled = false,
  required = false,
  stacked = false
}) => {
  return (
    <div className="mb-4 flex w-full items-start">
      {/* Label: take only as much space as needed */}
      <label
        htmlFor={name}
        className="text-base font-medium text-black  mr-4 whitespace-nowrap"
      >
        {label}
        {required && <span> *</span>}
      </label>

      {/* Radio Buttons: take remaining width and wrap if needed */}
      <div className={
        stacked
          ? "flex flex-col gap-2"
          : "flex flex-wrap gap-x-4 gap-y-2"
      }>
        {options.map(({ value, label: optionLabel }) => (
          <label
            key={value}
            htmlFor={`${name}-${value}`}
            className="flex items-center cursor-pointer"
          >
            <input
              id={`${name}-${value}`}
              type="radio"
              name={name}
              disabled={disabled}
              checked={String(selectedValue) === String(value)}
              onChange={() => onChange(value)}
              className="form-radio h-5 w-5 border-gray-700 checked:bg-blue-600"
            />
            <span className="ml-1 text-base text-black ">{optionLabel}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
